import CommonSession from '../commons/Session'

export default class DocumentSession extends CommonSession {}
